import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ContainerSteps = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 576px;
  min-height: 446px;
  max-height: calc(446px + 65px + 1rem);
  gap: 10px;
  border-radius: 10px;
  background: var(--white, #fff);

  @media (max-width: 540px) {
    width: 85%;
    padding: 30px 20px 30px 20px;
  }
`;
